import type { LegalContent } from '@/content/legal/impressum';

export const risikoDisclaimerContent: LegalContent = {
  title: 'Risikohinweis / Disclaimer',
  sections: [
    {
      title: 'Haftungsausschluss für Schulungsmaterial',
      content: [
        'Die Inhalte unseres Schulungsmaterials (Videomaterlial, PDF-Dokumemte) dienen ausschließlich der allgemeinen Information und sind keine Empfehlung zum Erwerb oder der Veräußerung bestimmter Finanzinstrumente und stellen somit keine Anlageberatung dar.'
      ]
    },
    {
      title: 'Keine Garantie und Haftung',
      content: [
        'Die Sven Bolz Trading Academy übernimmt keine Garantie und keine Haftung für die zur Verfügung gestellten Informationen und kann dadurch auch keinen Erfolg oder eine Vermögenssteigerung der MitgliederInnen/TeilnehmerInnen garantieren.'
      ]
    },
    {
      title: 'Individuelle Anlageziele',
      content: [
        'Die Sven Bolz Trading Academy kann nicht einschätzen, inwiefern die in den Schulungsmaterialien bereitgestellten Empfehlungen deinen Anlagezielen, deiner Risikobereitschaft und der Verlusttragfähigkeit entsprechen.'
      ]
    },
    {
      title: 'Eigenverantwortung',
      content: [
        'Jedes Mitglied, trifft Entscheidungen bezüglich seiner/ihrer Anlagestrategie aufgrund von Informationen oder Kommentaren in dem Schulungsmaterial in eigener Verantwortung.',
        '',
        'Das bedeutet wiederum, dass weder der/die Vorsitzende noch die Sven Bolz Trading Academy für einen Verlust haftet.'
      ]
    },
    {
      title: 'Keine steuerliche, rechtliche oder finanzielle Beratung',
      content: [
        'Auch die steuerlichen, rechtlichen und finanziellen Aspekte liegen nicht in der Verantwortung der Sven Bolz Trading Academy Eine Beratung wird diesbezüglich nicht angeboten oder durchgeführt.'
      ]
    },
    {
      title: 'Risiko des Totalverlustes',
      content: [
        'Der Handel mit Finanzprodukten (Aktien, Optionen, Optionsscheinen etc.) birgt immer und grundsätzlich das Risiko eines Totalverlustes.Die Sven Bolz Trading Academy und deren VertreterInnen bevorzugen es, den Handel auf das Kapital zu beschränken, das im Depot hinterlegt ist. Diverse Hebelmöglichkeiten des Brokers sollten nicht genutzt werden.'
      ]
    }
  ]
};
